import {
  DemoMultiPolygonRequest,
  DemoMultiPolygonResponse,
  DemoRadiiRequest,
  DemoRadiiResponse,
  DemoH3Response,
  DemoH3ByPolygonRequest,
  DemoRawRadiusRequest,
  DemoRawResponse,
  DemoRawMultiPolygonRequest,
} from 'src/common-services/types/demo-types'
import { convertToObjects } from 'src/common-services/utils/result-processing'
import { BaseClient } from 'src/common-services/clients/base-client'
import { ShapesRequest } from 'src/common-services/types/properties-types'

export class DemoClient extends BaseClient {
  getByRadii(request: DemoRadiiRequest): Promise<DemoRadiiResponse> {
    return this.call<DemoRadiiResponse>('/demos/by-radii', 'POST', { data: request })
  }

  getByMultiPolygon(request: DemoMultiPolygonRequest): Promise<DemoMultiPolygonResponse> {
    return this.call('/demos/by-multi-polygon', 'POST', { data: request })
  }

  getRawByRadius(request: DemoRawRadiusRequest): Promise<DemoRawResponse> {
    return this.post('/demos/raw/by-radii', request)
  }

  getRawByMultiPolygon(request: DemoRawMultiPolygonRequest): Promise<DemoRawResponse> {
    return this.post('/demos/raw/by-multi-polygon', request)
  }

  async getH3sByPolygon(request: DemoH3ByPolygonRequest): Promise<DemoH3Response> {
    const res = await this.post<Array<Array<string | number>>>('/demos/h3/by-polygon', request)
    return convertToObjects(request.fields, res)
  }

  getBlockGroupPolygons(request: ShapesRequest): Promise<{ id: string; polygon: string }[]> {
    return this.post('/demos/block-group-polygons', request)
  }
}
